"use strict";
const { alcoholTaxCalculator } = require('../article/alcohol-tax-calculator');
class Invariantor {
    constructor(complaintToEnsure) {
        this.complaint = complaintToEnsure;
        this.complaint.complaintRows = complaintToEnsure.complaintRows || [];
    }
    ensureAlcTaxInRows() {
        this.complaint.complaintRows = this.complaint.complaintRows.map(x => ({
            ...x,
            alcoholTax: alcoholTaxCalculator(x.article) * (x.quantity || 0),
        }));
        return this;
    }
    value() {
        return { ...this.complaint };
    }
}
module.exports = complaintToEnsure => {
    const hadRows = !!complaintToEnsure.complaintRows;
    const ensured = new Invariantor(complaintToEnsure)
        .ensureAlcTaxInRows()
        .value();
    if (!hadRows) {
        delete ensured.complaintRows;
    }
    return ensured;
};
